const KB = 1024
const MB = KB * KB

export const MAX_DEFAULT_FILE_SIZE = 10 * MB
export const MAX_PROFILE_IMAGE_SIZE = 2 * MB

export const PLACEHOLDER_AVATAR_PATH = '/assets/avatar.png'
export const PLACEHOLDER_NOIMAGE_PATH = '/assets/noimage.png'

export const PUBLIC_STORAGE_URL = 'https://kintsu-public.s3.amazonaws.com'
